import { render, staticRenderFns } from "./confirmFrame.vue?vue&type=template&id=5f559521&scoped=true&"
import script from "./confirmFrame.vue?vue&type=script&lang=js&"
export * from "./confirmFrame.vue?vue&type=script&lang=js&"
import style0 from "./confirmFrame.vue?vue&type=style&index=0&id=5f559521&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f559521",
  null
  
)

export default component.exports